import { history } from 'duck/store'
import React from 'react'
import { TableColumn } from 'scenes/Dashboard/components-next/Table'
import { makeStyles } from 'tss-react/mui'

import SectionLoading from '../../../../components/SectionLoading'
import { getCorporateDetailsPath } from '../../CorporateManager.routes'
import { useCorporateListViewStore } from './CorporateListViewStore'
import { CorporateTable } from '../../components/CorporateTable'
import { Corporate } from '../../../../../../entities-next/corporate'
import { CorporateTableActions } from './components'

export type CorporateListViewContentProps = {
  className?: string
}

export function CorporateListViewContent({ className }: CorporateListViewContentProps) {
  const {
    state: { status, data = [], currentPage, isPreviousData, limit },
    actions: { goToPage },
  } = useCorporateListViewStore()
  const { classes } = useStyles()
  const isLoading = status === 'loading' || isPreviousData

  return (
    <div className={className}>
      {isLoading && <SectionLoading className={classes.loading} />}
      <CorporateTable
        data={data}
        currentPage={currentPage}
        limit={limit}
        onChangePage={goToPage}
        extraColumns={actionsRow}
        onRowSelect={onRowSelect}
      />
    </div>
  )
}

function onRowSelect(corporate: Corporate) {
  history.push(getCorporateDetailsPath(corporate.id))
}

const actionsRow: TableColumn<Corporate>[] = [
  {
    Header: 'Actions',
    accessor: getCorporateActionsColumn,
    preventEvents: true,
    width: 50,
  },
]

function getCorporateActionsColumn(corporate: Corporate) {
  return <CorporateTableActions corporate={corporate} />
}

const useStyles = makeStyles()({
  content: {
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
})
